:host {
    display: block;
    position: fixed;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    box-sizing: border-box;
    box-shadow: -10px 0 70px -2px rgba(0, 0, 0, 0.5);
}

:host * {
    box-sizing: border-box;
    font-family: "Frutiger-Light", sans-serif;
}

.drawer {
    position: relative;
    display: block;
    height: 100%;
    background: #fff;
    transition: all 0.3s ease;
    overflow: hidden;
}

:host(:not(:hover)) .drawer {
    width: 46px !important;
}

.item {
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    cursor: pointer;
    transition: all 0.3s ease;
    background: white;
    border: 0;
    padding: 0;
    appearance: none;
    margin: 5px 0;
    font-size: 18px;
}

.item--scroll-to-top {
    border-top: solid 1px $color-gray-70;
    height: 41px;
}

.item--scroll-to-top .item__name {
    padding-top: 11px;
}

.scroll-to-top-icon,
.item__indicator {
    display: block;
    border-radius: 100%;
    width: 36px;
    height: 36px;
    text-align: center;
    position: relative;
    margin: 0 5px;
    transition: background 0.25s ease;
}

.scroll-to-top-icon {
    padding-top: 6px;
    color: $color-gray-70;
    font-size: 20px;
}

.item:hover .scroll-to-top-icon {
    color: var(--ux-button-primary-bg-color);
}

.item--active .item__indicator,
.item:hover .item__indicator {
    background: var(--ux-button-primary-bg-color);
}

.item__indicator::before {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 28px;
    height: 28px;
    border-radius: 100%;
    border: solid 2px #fff;
}

.item__bullet::before {
    background-color: $color-gray-70;
    border-radius: 50px;
    content: "";
    display: block;
    height: 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: background-color 250ms ease-in-out;
    width: 10px;
}

.item--active .item__bullet::before,
.item:hover .item__bullet::before {
    background-color: #fff;
}

.item__number {
    font-family: "Frutiger-Bold", sans-serif;
    color: $color-gray-70;
    padding-top: 7px;
    display: block;
}

.item--active .item__number,
.item:hover .item__number {
    color: #fff;
}

.item__name {
    display: block;
    position: absolute;
    left: 46px;
    top: 0;
    height: 46px;
    white-space: nowrap;
    padding: 8px 20px 5px 10px;
    color: $color-gray-text;
}

.item--active .item__name {
    color: $color-black;
}
